import { render } from "./VuexPostalCodeFormItem.vue?vue&type=template&id=3aee3b3c"
import script from "./VuexPostalCodeFormItem.vue?vue&type=script&lang=js"
export * from "./VuexPostalCodeFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2852037359/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__